import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

export default function RutasFerroviarias() {
  const [q, setQ] = useState("");
  const [rutas, setRutas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    authFetch('/api/RutaFerroviaria')
      .then((res) => {
        if (!res.ok) throw new Error('Error al cargar rutas: ' + res.statusText);
        return res.json();
      })
      .then((data) => {
        setRutas(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setRutas([]);
        setLoading(false);
      });
  }, []);

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return rutas;
    return rutas.filter(r => r.nombre.toLowerCase().includes(t));
  }, [q, rutas]);

  const handleAgregar = () => navigate('/admin/rutas/agregar');
  const handleEditar = (ruta) => navigate(`/admin/rutas/editar/${ruta.id}`);

  const handleDelete = async (ruta) => {
    if (!window.confirm(`¿Eliminar la ruta "${ruta.nombre}"?`)) return;

    try {
      const response = await authFetch(`/api/RutaFerroviaria/${ruta.id}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('No se pudo eliminar la ruta.');
      
      setRutas(prev => prev.filter(p => p.id !== ruta.id));
      alert('Ruta eliminada.');
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Rutas Ferroviarias</h1>
        <button className="aseg-btn" onClick={handleAgregar}>
          Agregar Ruta
        </button>
      </header>

      <SearchInput
        placeholder="Buscar ruta..."
        value={q}
        onChange={(e) => setQ(e.target.value)} 
      />

      {loading && <p>Cargando rutas...</p>}
      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre de Ruta</th>
                  <th>N.º Estaciones</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.estaciones ? r.estaciones.length : 0}</td>
                      <td className="td-acciones">
                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="aseg-empty">
                      No se encontraron rutas.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
}